import styled, { createGlobalStyle } from 'styled-components';
import backgroundUrl from '../../stories/assets/Splash.jpg';

export const StyledBackground = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url('${backgroundUrl}');
  z-index: -1;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const StyledDiv = styled.div`
@media only screen and (max-width: 820px)
{
  display: none;
}
`;

export const FormLayoutGlobalStyles = createGlobalStyle`
  div:has(+ #login-widget) {
    max-width: 560px;
  }
  div#login-widget main{
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }
  #okta-sign-in .custom-radio label, 
  #okta-sign-in .custom-radio label.hover,
  #okta-sign-in .custom-radio label.focus,
  #okta-sign-in .custom-radio label.checked{
    background-position-x: -13px !important;
    padding-left: 26px !important;
    left: 0 !important;
  }
  @media (min-resolution: 192dpi){
    #okta-sign-in .custom-radio label.checked,
    #okta-sign-in .custom-radio label.checked.focus {
      background-position: -13px -182px !important;
      padding-left: 26px !important;
      left: 0 !important;
    }
  }

  /* Global SVG color overrides for logo classes */
  svg .st0 {
    fill: var(--primary-color, #064dd9) !important;
  }
  svg .st1 {
    fill: var(--secondary-color, #8c8c87) !important;
  }
`;
